module.exports = __webpack_public_path__ + "img/yuangong2.e639f6ba.jpg";